import React from 'react';

// Layouts
import Default from '../Layouts/Default';
import LoginAndRegister from '../Layouts/LoginAndRegister';
import TwoColumnWithImage from '../Layouts/TwoColumnWithImage';

type Props = {
  settings: any;
};

export const AccountLanding = ({ settings }: Props) => {
  const { section, signUpFields } = settings;
  const {
    layout,
    color_schema
  } = section;

  console.log('Layout', settings);
  const sideImage = settings.blocks.find((block: any) => block.type === 'side_image');
  const loginForm = settings.blocks.find((block: any) => block.type === 'login_form');
  const forgotPassword = settings.blocks.find((block: any) => block.type === 'forgot_password');
  const registerCta = settings.blocks.find((block: any) => block.type === 'register_cta');

  // Extract block settings from settings
  const blockSettings = {
    loginForm: loginForm?.settings || {},
    registerCta: registerCta?.settings || {},
    sideImage: sideImage?.settings || {},
    forgotPassword: forgotPassword?.settings || {},
    newsletterSignup: settings.newsletterSignup || {}
  };

  // Render appropriate layout based on section settings
  const renderLayout = () => {
    switch (layout) {
      case 'two_column':
        return (
          <div className="flex flex-col lg:flex-row gap-8">
            <div className="w-full lg:w-1/2">
              <LoginAndRegister 
                section={section}
                signUpFields={signUpFields}
                headerColorSchema={color_schema}
                blockSettings={blockSettings}
              />
            </div>
          </div>
        );
      case 'two_column_image':
        return (
          <TwoColumnWithImage
            section={section}
            signUpFields={signUpFields}
            headerColorSchema={color_schema}
            blockSettings={blockSettings}
          />
        );
      default:
        return (
          <Default
            section={section}
            signUpFields={signUpFields}
            headerColorSchema={color_schema}
            blockSettings={blockSettings}
          />
        );
    }
  };

  return (
    <div className="account-page min-h-screen flex flex-col">
      <div className="account-page__container w-full flex-grow py-8">
        <div className="account-page__wrapper flex flex-col lg:flex-row w-full gap-8 justify-center">
          {renderLayout()}
        </div>
      </div>
    </div>
  );
};

export default AccountLanding;